import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow: auto;
`
export const Content = styled.div`
  width: calc(80vw - 350px);
  left: 250px;
  height: 100vh;
  overflow-y: visible;
`
export const CompanyCard = styled.div`
  background: #ffffff;
  border: none;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 47px 70px 70px 47px;
`
export const FormContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
`
export const InformationCompany = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-self: center;
  width: 50%;
  align-items: center;
  gap: 50px;
`

interface ILabelDiv {
  alignItems?: string
  justifyContent?: string
  width?: string
  height?: string
}

export const FormContainerItem = styled.div<ILabelDiv>`
  align-self: center;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 30px;
  justify-content: ${(props) => props.justifyContent || 'space-between'};
  text-align: start;
`
export const IconSvgProfile = styled.svg`
  color: #2d749c;
  fill: #2d749c;
  width: 24px;
  height: 24px;
`

export const LabelDiv = styled.div<ILabelDiv>`
  width: 50%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: ${(props) => props.alignItems || 'center'};
  justify-content: ${(props) => props.justifyContent || 'flex-start'};
`

export const Label = styled.label`
  font-size: 14px;
  color: #1f2124;
  font-weight: 600;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
`

export const BluesiteTable = styled.table`
  width: 100%;
  text-align: left;
  border-collapse: collapse;
`
export const TableDivider = styled.hr`
  border: 1px solid #1f2124;
  width: 100%;
`
export const TableHeaders = styled.thead`
  margin-bottom: 30px;
  border-bottom: 1px solid #1f2124;
  padding: 0.3em;
  justify-content: space-between;
`
export const ActionsCell = styled.th`
  justify-content: flex-end;
  width: 25%;
`
export const TableBody = styled.tbody`
  border-top: 1px solid;
  padding-top: 30px;
  justify-content: space-between;
  .link-editar {
    font-family: 'Public Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 13px;
    line-height: 22px;
    color: #2d749c;
  }
`

export const EditLinkWrapper = styled.div`
  display: flex;
  float: right;
  color: #2d749c;
  font-size: 15px;
  font-weight: bold;
  align-items: center;
  gap: 5px;
`

export const TableSelect = styled.select`
  width: 63px;
  height: 50px;
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  border: none;
  margin: 10px;
  padding: 10px;
`
export const OptionSelect = styled.option`
  padding: 10px;
`
export const UpdateLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #e44646;
  font-weight: bold;
  cursor: pointer;
`

export const ActionIcon = styled.svg`
  fill: #e44646;
  clip-rule: evenodd;
  fill-rule: evenodd;
  stroke-linejoin: round;
  stroke-miterlimit: 2;
  width: 24px;
  height: 24px;
  margin-right: 5px;
`

interface IRow {
  height?: string
  width?: string
  justifyContent?: string
  alignItems?: string
}

export const Row = styled.div<IRow>`
  display: flex;
  flex-direction: row;
  justify-content: ${(props) => props.justifyContent || 'flex-start'};
  align-items: ${(props) => props.alignItems || 'center'};
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || 'auto'};
`
export const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 40px;
  margin-top: 40px;
`
export const Card = styled.div`
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  display: flex;
  flex-direction: row;
  width: 85%;
  height: 92px;
  padding: 12px;
`

export const CardDescriptionSection = styled.div`
  margin: 10px;
`
export const PointerLabel = styled.label`
  cursor: pointer;
`

// Nuevos componentes para la vista de inventario con historial

export const InventoryToolbar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-top: 12px;

  && .inventory-back-button,
  && .inventory-new-button {
    border-radius: 12px;
    box-shadow: 0 3px 9px rgba(37, 92, 123, 0.12);
  }

  && .inventory-back-button {
    background: #eaf3f8;
    border: 1px solid #b9d2e0;
    color: #286384;
  }

  && .inventory-new-button {
    background: #397a9d;
    border: 1px solid #397a9d;
    color: #ffffff;
  }

  && .inventory-back-button:hover {
    background: #dcecf4;
    border-color: #9fc4d7;
    box-shadow: 0 5px 12px rgba(37, 92, 123, 0.16);
  }

  && .inventory-new-button:hover {
    background: #2e698a;
    border-color: #2e698a;
    box-shadow: 0 5px 12px rgba(37, 92, 123, 0.18);
  }

  && .inventory-back-button:active,
  && .inventory-new-button:active {
    box-shadow: 0 2px 5px rgba(37, 92, 123, 0.14);
  }

  @media (max-width: 620px) {
    flex-wrap: wrap;
  }
`

export const InventoryContainer = styled.div`
  width: 100%;
  margin-top: 12px;
`

export const InventoryListContainer = styled.div`
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  overflow: hidden;

  h6 {
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: 600;
  }
`

export const InventoryDetailContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;

  && .inventory-detail-primary-button,
  && .inventory-detail-secondary-button {
    border-radius: 12px;
    box-shadow: 0 3px 9px rgba(37, 92, 123, 0.12);
  }

  && .inventory-detail-primary-button {
    background: #397a9d;
    border: 1px solid #397a9d;
    color: #ffffff;
  }

  && .inventory-detail-secondary-button {
    background: #eaf3f8;
    border: 1px solid #b9d2e0;
    color: #286384;
  }

  && .inventory-detail-primary-button:hover {
    background: #2e698a;
    border-color: #2e698a;
    box-shadow: 0 5px 12px rgba(37, 92, 123, 0.18);
  }

  && .inventory-detail-secondary-button:hover {
    background: #dcecf4;
    border-color: #9fc4d7;
    box-shadow: 0 5px 12px rgba(37, 92, 123, 0.16);
  }
`

export const InventoryDetailHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 16px 24px;
  border-bottom: 1px solid #e5edf4;

  h6 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    text-align: left;
  }

  > div {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;

    button {
      margin: 0;
      min-height: 40px;
    }
  }

  @media (max-width: 760px) {
    flex-direction: column;
    align-items: flex-start;

    > div { justify-content: flex-start; }
  }
`

export const InventoryDetailContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 24px 20px;
`

export const InventoryInfoItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #f1f1f1;

  &:last-child {
    border-bottom: none;
  }

  strong {
    font-weight: 600;
  }
`

export const InventoryHistoryContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  overflow: hidden;
`

export const InventoryHistoryHeader = styled.div`
  padding: 15px 20px;
  border-bottom: 1px solid #f1f1f1;

  h6 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
  }
`

export const InventoryHistoryContent = styled.div`
  padding: 20px;
  flex: 1;
  overflow: visible;
  max-height: none;

  p {
    text-align: center;
    color: #888;
    margin-top: 20px;
  }
`

export const HistoryItem = styled.div`
  margin-bottom: 20px;
  padding: 15px;
  border-radius: 8px;
  background-color: #f8f9fa;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
`

export const HistoryItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-bottom: 5px;
  border-bottom: 1px solid #eaeaea;

  span {
    color: #666;
    font-size: 14px;
  }

  strong {
    font-weight: 600;
    color: #2d749c;
  }
`

export const HistoryItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  span {
    font-size: 14px;
  }
`

export const NoInventorySelected = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 40px;

  p {
    color: #888;
    text-align: center;
    font-size: 16px;
  }
`

// Nuevos estilos para edición de inventario
export const EditInventoryForm = styled.div`
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 16px;
  width: 100%;
  max-width: 1120px;
  margin: 0 auto;

  @media (max-width: 900px) {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  @media (max-width: 620px) {
    grid-template-columns: minmax(0, 1fr);
  }
`

export const EditFormRow = styled.div`
  grid-column: span 4;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 6px;

  &.field-2 { grid-column: span 2; }
  &.field-3 { grid-column: span 3; }
  &.field-6 { grid-column: span 6; }
  &.field-8 { grid-column: span 8; }
  &.field-9 { grid-column: span 9; }
  &.field-10 { grid-column: span 10; }

  .MuiOutlinedInput-root {
    border-radius: 8px;
    min-height: 42px;
  }

  .inventory-field-value,
  .inventory-switch-value {
    box-sizing: border-box;
    min-height: 42px;
    border: 1px solid #cbd8e3;
    border-radius: 8px;
    background: #f7fafc;
    padding: 4px 12px;
    display: flex;
    align-items: center;
    gap: 8px;
    color: #24445a;
  }

  .inventory-field-value {
    overflow-wrap: anywhere;
  }

  .inventory-code-action {
    margin-left: auto;
    flex-shrink: 0;
    line-height: 0;
  }

  .inventory-switch-value .MuiFormControlLabel-root {
    margin: -8px 0;
  }

  @media (max-width: 900px) {
    grid-column: span 3;
    &.field-8, &.field-9, &.field-10 { grid-column: span 6; }
    &.field-6 { grid-column: span 6; }
    &.field-3 { grid-column: span 3; }
    &.field-2 { grid-column: span 2; }
  }

  @media (max-width: 620px) {
    &, &.field-2, &.field-3, &.field-6, &.field-8, &.field-9, &.field-10 {
      grid-column: 1;
    }
  }
`

export const EditFormLabel = styled.label`
  font-weight: 600;
  font-size: 13px;
  color: #29475d;
`

export const EditFormActions = styled.div`
  grid-column: 1 / -1;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 4px;

  @media (max-width: 620px) {
    flex-wrap: wrap;
  }
`

// Indicador visual para fila seleccionada
export const SelectedRow = styled.div`
  position: absolute;
  left: 0;
  height: 100%;
  width: 6px;
  background-color: #c6016b;
  z-index: 1;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  box-shadow: 0 0 5px rgba(198, 1, 107, 0.5);
`

// Añadir un nuevo estilo para las filas seleccionadas
export const TableRowSelected = styled.tr`
  background-color: rgba(198, 1, 107, 0.08);
  position: relative;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(198, 1, 107, 0.12);
  }

  td {
    position: relative;
  }

  td:first-child {
    border-left: 4px solid #c6016b;
  }
`
